<template>
    <div class="task-box">
        <div class="tab-box">
           <div class="tab-left">
            <div v-for="(item,index) in tabOptions" @click="changeTab(item)" :class="{'tab-active':currentTab==item.value}" class="tab-item" :key="index">
                <p>{{ item.label }}</p>
            </div>
           </div>
            <div class="search-task-box" v-if="['theoryExamine','virtualExamine','allExamine'].includes(currentTab)">
                <!-- <el-select v-model="examineType" placeholder="请选择考核类型">
                    <el-option
                    v-for="item in examineTypeOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select> -->
                <el-select style="margin-left: 2rem;" v-model="examineStatus" placeholder="请选择考核状态">
                    <el-option
                    v-for="item in examineStatusOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="table-content-box">
            <study-task v-if="currentTab=='studyTask'" ref="studyTask" :name="name"></study-task>
            <practical-task v-else-if="currentTab=='praticalTask'" ref="praticalTask" :name="name"></practical-task>
            <theory-task v-else-if="currentTab=='theoryExamine'" ref="theoryExamine" :name="name" :examineStatus="examineStatus"></theory-task>
            <virtual-task v-else-if="currentTab=='virtualExamine'" ref="virtualExamine" :name="name" :examineStatus="examineStatus"></virtual-task>
            <all-task v-else-if="currentTab=='allExamine'" ref="allExamine" :name="name" :examineStatus="examineStatus"></all-task>
        </div>
    </div>
</template>

<script>
import AllTask from './myselfTask/AllTask.vue';
import ExamineTask from './myselfTask/ExamineTask.vue';
import PracticalTask from './myselfTask/PracticalTask.vue';
import StudyTask from './myselfTask/StudyTask.vue';
import TheoryTask from './myselfTask/TheoryTask.vue';
import VirtualTask from './myselfTask/VirtualTask.vue';
    export default {
        props:['name'],
        components: { StudyTask, ExamineTask, PracticalTask, TheoryTask, VirtualTask, AllTask },
        data(){
            return {
                /**tab切换 */
                tabOptions:[
                    {
                        label:'课程任务',
                        value:'studyTask'
                    },
                    {
                        label:'实训任务',
                        value:'praticalTask'
                    },
                    {
                        label:'理论考核',
                        value:'theoryExamine'
                    },
                    {
                        label:'虚仿考核',
                        value:'virtualExamine'
                    },
                    {
                        label:'综合考核',
                        value:'allExamine'
                    },
                ],
                /**考核类型可选项 */
                examineTypeOpts:[
                    {
                        label:'请选择考核类型',
                        value:'',
                    },
                    {
                        label:'理论考核',
                        value:'0'
                    },
                    {
                        label:'虚仿考核',
                        value:'1'
                    },
                    {
                        label:'综合考核',
                        value:'2'
                    }
                ],
                /**考核状态可选项 */
                examineStatusOpts:[
                    {
                        label:'请选择考核状态',
                        value:''
                    },
                    {
                        label:'未开始',
                        value:'0'
                    },
                    {
                        label:'进行中',
                        value:'1'
                    },
                    {
                        label:'已完成',
                        value:'2'
                    },
                    {
                        label:'未考',
                        value:'3'
                    },
                ],
                examineType:'',
                examineStatus:'',
                /**当前选中tab */
                // currentTab:'studyTask',
            }
        },
        computed:{
            currentTab(){
                return this.$store.state.personCenter.taskTab;
            }
        },
        methods:{
            /**切换tab */
            changeTab(item){
                this.$store.commit('personCenter/changeTaskTab',item.value);
            },
            search(){
                let dom=this.$refs[this.currentTab];
                if(dom){
                    dom.search();
                }
            },
            /**刷新当前列表 */
            refreshList(){
                let obj={
                    theoryExamine:'pageExamineStd',
                    allExamine:'pageExamineStd'
                };
                let dom=this.$refs[this.currentTab];
                if(dom&&obj[this.currentTab]){
                    dom[obj[this.currentTab]]();
                }
            }
        },
        mounted(){
            const channel = new BroadcastChannel('my_channel');
            channel.onmessage = (e) => {
                if(e.data.text='submit'){
                    this.refreshList();
                }
            };
        },
        beforeDestroy(){
            this.$store.commit('personCenter/changeTaskTab','studyTask');
        }
    }
</script>

<style lang="less" scoped>
.task-box{
    height: 100%;
    color: #334681;
}
.tab-box{
    padding: 2.5rem 0;
    display: flex;
    position: relative;
    .tab-left{
        display: flex;
        column-gap: 2rem;
        width: calc(100% - 26.5rem);
        overflow: auto;
        &> :nth-child(n){
            cursor: pointer;
        }
    }
    .search-task-box{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
.tab-active{
    color: var(--blue) !important;
}
.table-content-box{
    height: calc(100vh -  40.5rem);
}
</style>